export const checkGrossMargin = (
  grossMargin: number,
): 'danger' | 'warning' | 'success' => {
  if (!grossMargin && grossMargin !== 0) return `danger`

  if (grossMargin <= 0) return `danger`

  if (grossMargin > 0 && grossMargin < 0.07) return `warning`

  return `success`
}

export const checkCm3Margin = (
  cm3Margin: number,
): 'danger' | 'warning' | 'success' => {
  if (!cm3Margin && cm3Margin !== 0) return `danger`

  if (cm3Margin <= 0) return `danger`

  if (cm3Margin > 0 && cm3Margin < 0.02) return `warning`

  return `success`
}

export const checkIfMarginIsInvalid = ({
  grossMargin,
  cm3Margin,
}: {
  grossMargin: number
  cm3Margin: number
}): boolean => {
  const gross = checkGrossMargin(grossMargin)
  const cm3 = checkCm3Margin(cm3Margin)

  return !(gross === 'success' && cm3 === 'success')
}
